import { render, staticRenderFns } from "./OtelCosts.vue?vue&type=template&id=62c19a95&scoped=true"
import script from "./OtelCosts.vue?vue&type=script&lang=js"
export * from "./OtelCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c19a95",
  null
  
)

export default component.exports